import { AbstractStorage } from '@core/_services/abstract-storage.interface';
import { Injectable } from '@angular/core';
import { logger } from 'codelyzer/util/logger';

const cookieNameRegExp = (name) =>
  new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)');

type StringTuple = [string, any];

interface CookieOptionsInterface {
  expires?: number | Date | string;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'Lax' | 'None' | 'Strict';
  'max-age'?: number;
}

@Injectable()
export class BrowserCookieStorage implements AbstractStorage {
  getItem(name) {
    const matches = document.cookie.match(cookieNameRegExp(name));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  removeItem(name) {
    this.setItem(name, '', { 'max-age': -1 });
  }

  setItem(name, value, options: CookieOptionsInterface = {}) {
    options = { path: '/', ...options };

    if (options.expires instanceof Date) options.expires = options.expires.toUTCString();

    let updatedCookie = encodeURIComponent(name) + this.addEqualSign(encodeURIComponent(value));

    Object.entries(options).forEach(([key, value]: StringTuple) => {
      updatedCookie += this.addSemicolon(key);
      if (value !== true) updatedCookie += this.addEqualSign(value);
    });

    document.cookie = updatedCookie;
  }

  private addSemicolon = (str: string) => '; ' + str;
  private addEqualSign = (str: string) => '=' + str;
}
